<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="privacy" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>Privacy Policy</h1>
      <p>
        At
        <router-link to="/">GB-Wave.com</router-link>,
        we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect information when you visit our website.
      </p>

      <h2>Information We Collect</h2>
      <p>When you visit GB Wave, we may collect limited information automatically, including:</p>
      <ul>
        <li>Browser type</li>
        <li>Device information</li>
        <li>IP address</li>
        <li>Pages visited</li>
        <li>Website usage data</li>
      </ul>
      <p>This information helps us improve website performance and user experience.</p>

      <h2>Cookies</h2>
      <p>
        GB Wave uses cookies and similar technologies to improve website functionality, analyze traffic, and provide a better browsing experience.
      </p>
      <p>
        Third-party services, including analytics and advertising providers, may use cookies according to their own privacy policies.
      </p>

      <h2>How We Use Information</h2>
      <p>Collected information may be used to:</p>
      <ul>
        <li>Improve website content</li>
        <li>Analyze visitor behavior</li>
        <li>Maintain website security</li>
        <li>Improve user experience</li>
      </ul>

      <h2>Third-Party Services</h2>
      <p>
        Our website may use third-party services such as analytics tools and advertising networks. These services may collect information according to their own policies.
      </p>

      <h2>Contact Us</h2>
      <p>If you have questions about this Privacy Policy, please contact us.</p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'Privacy',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Privacy Policy', current: true },
      ],
    };
  },
};
</script>
